const root = '/certificates';

export default {
  root,
} as const;
